// extracted by mini-css-extract-plugin
module.exports = {"actions":"ComponentToolbar--actions"};